import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fl text-left"
}
const _hoisted_2 = {
  id: "DetailSettingsContent",
  class: "w100 mb20"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = { class: "mt40" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "有効期限設定", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "dgrey fs13 mb10" }, " 調整ページを自動的に終了しないように設定します。有効期限を設定しない場合、終了させない限り調整ページが公開し続けますので、ご注意ください。 ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: `expiration_type_`,
  class: "fs13"
}, "有効期限を設定しない", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "mt40"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "プライベート設定", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "dgrey fs13 mb10" }, "企業の管理者権限の方は、調整ページのユーザーグループ共有をオフにできます。", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: `share_type_`,
  class: "fs13"
}, "ユーザーグループに調整ページを共有しない", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = {
  class: "w100 mt40",
  style: {}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "調整相手のイベント登録設定", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = { class: "dgrey fs13 mb10" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = { class: "fl w60" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = {
  key: 2,
  class: "w100 mt40",
  style: {}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "カレンダーに登録するイベント情報", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "dgrey fs13 mb10" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = { class: "ml40 fl w60" }
const _hoisted_37 = {
  key: 0,
  class: "fs18 pad10 fw600"
}
const _hoisted_38 = {
  key: 1,
  class: "fs18 pad10 fw600"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_42 = {
  key: 2,
  class: "pad10 fs14 lh18 kaigyo"
}
const _hoisted_43 = ["textContent"]
const _hoisted_44 = {
  key: 3,
  class: "pad10 fs14 lh18"
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_63 = {
  key: 3,
  class: "mt40"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "管理側メールタイトルに追加文字設定", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_66 = {
  class: "fl ml2 w100",
  style: {}
}
const _hoisted_67 = {
  class: "fl",
  style: {"width":"calc(100% - 140px)"}
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs13 fl dgrey",
  style: {}
}, " オーナーや担当者宛に送信されるメールのタイトルに、追加で文字列を設定できます。 ", -1)
const _hoisted_69 = { key: 0 }
const _hoisted_70 = {
  class: "fl",
  style: {"width":"calc(100% - 140px)"}
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_74 = { class: "mt40" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "複製時の権限共有", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_77 = {
  class: "fl ml2 w100",
  style: {}
}
const _hoisted_78 = {
  class: "fl",
  style: {"width":"calc(100% - 140px)"}
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs13 fl dgrey",
  style: {}
}, " 公開ページを複製した際に、複製元の公開ページの権限を共有しているメンバーに複製先の公開ページにも共有します。 ", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_82 = {
  key: 4,
  class: "mt40"
}
const _hoisted_83 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "調整内容変更可能", -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_85 = {
  class: "fl ml2 w100",
  style: {}
}
const _hoisted_86 = {
  class: "fl",
  style: {"width":"calc(100% - 140px)"}
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs13 fl dgrey",
  style: {}
}, " 調整相手が自由に調整内容（ヘッダー画像やタイトルなど）を変更できるようになります。 ", -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_90 = {
  key: 5,
  class: "mt40"
}
const _hoisted_91 = {
  class: "header_title fs18 fl",
  style: {}
}
const _hoisted_92 = ["src"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("p", { class: "fw600 fs18 fl" }, "Google Analytics設定", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fw600" }, "クロスドメインを利用する場合、親要素のドメインを入力（カンマで複数設定可）", -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_99 = {
  key: 6,
  class: "mt40"
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_104 = {
  key: 7,
  class: "mt40"
}
const _hoisted_105 = /*#__PURE__*/_createStaticVNode("<div class=\"header_title fs18 fl\" style=\"\"><p class=\"header_title fs18 fl\" style=\"\">メンバーの表示設定</p><div class=\"clear\"></div><p class=\"fs13 fl dgrey\" style=\"\"> 調整相手がメールから調整ページに入った場合に、出席者の情報をマスクし個人情報を表示しません。 </p><div class=\"clear\"></div></div><div class=\"clear\"></div>", 2)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("label", {
  for: `mask_members_info_`,
  class: "fs13"
}, "調整ページ内でメンバーの情報をマスクする", -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_109 = {
  key: 8,
  class: "mt40"
}
const _hoisted_110 = /*#__PURE__*/_createStaticVNode("<div class=\"header_title fs18 fl\" style=\"\"><p class=\"header_title fs18 fl\" style=\"\">フォーム自動送信</p><div class=\"clear\"></div><p class=\"fs13 fl dgrey\" style=\"\"> waaq以外のフォームから自動でフォーム内容を読み取り、公開ページのフォームに埋め、限定公開ページを作成します。 </p><div class=\"clear\"></div></div><div class=\"clear\"></div>", 2)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_114 = {
  key: 9,
  class: "mt40"
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "IPアドレス設定", -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_117 = {
  class: "fl ml2 w100",
  style: {}
}
const _hoisted_118 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs16 fl",
  style: {"width":"140px"}
}, "ホワイトリスト", -1)
const _hoisted_119 = {
  class: "fl",
  style: {"width":"calc(100% - 140px)"}
}
const _hoisted_120 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs13 fl dgrey",
  style: {}
}, [
  /*#__PURE__*/_createTextVNode(" アクセス可能なIPアドレスを設定できます。その他のIPアドレスからアクセスがあった場合、「見つかりません」のページを返します。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 入力はカンマ（,）つなぎで有効です。ホワイトリストとブラックリストに同じIPアドレスが設定されている場合、ブラックリストが優先されます。 ")
], -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_122 = {
  class: "fl ml2 w100",
  style: {}
}
const _hoisted_123 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs16 fl",
  style: {"width":"140px"}
}, "ブラックリスト", -1)
const _hoisted_124 = {
  class: "fl",
  style: {"width":"calc(100% - 140px)"}
}
const _hoisted_125 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs13 fl dgrey",
  style: {}
}, [
  /*#__PURE__*/_createTextVNode(" アクセスを受け付けないIPアドレスを設定できます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 入力はカンマ（,）つなぎで有効です。 ")
], -1)
const _hoisted_126 = /*#__PURE__*/_createElementVNode("span", { class: "orange" }, "※ 範囲指定をする場合は、IPアドレス末尾に「/（スラッシュ）」とサブネットマスクのビット数を付与してください。", -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_128 = {
  key: 0,
  class: "w100 mt40"
}
const _hoisted_129 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "フォームに入力可能なメールアドレス", -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_131 = {
  class: "fl ml2 w100",
  style: {}
}
const _hoisted_132 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs16 fl",
  style: {"width":"140px"}
}, "ホワイトリスト", -1)
const _hoisted_133 = {
  class: "fl",
  style: {"width":"calc(100% - 140px)"}
}
const _hoisted_134 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs13 fl dgrey",
  style: {}
}, [
  /*#__PURE__*/_createTextVNode(" フォームに入力可能なメールアドレス（部分一致）を設定できます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 入力はカンマ（,）つなぎで有効です。ホワイトリストとブラックリストに同じメールアドレスが設定されている場合、ブラックリストが優先されます。 ")
], -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_137 = {
  class: "fl ml2 w100",
  style: {}
}
const _hoisted_138 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs16 fl",
  style: {"width":"140px"}
}, "ブラックリスト", -1)
const _hoisted_139 = {
  class: "fl",
  style: {"width":"calc(100% - 140px)"}
}
const _hoisted_140 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs13 dgrey",
  style: {}
}, [
  /*#__PURE__*/_createTextVNode(" フォームのメールアドレスに入力できないできないメールアドレス（部分一致）を設定できます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 入力はカンマ（,）つなぎで有効です。 ")
], -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InstantRoomSettings = _resolveComponent("InstantRoomSettings")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_OptionalConnectedCalendar = _resolveComponent("OptionalConnectedCalendar")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_HubspotNotificationContent = _resolveComponent("HubspotNotificationContent")!
  const _component_SalesforceNotificationContent = _resolveComponent("SalesforceNotificationContent")!
  const _component_GoogleSpreadSheetNotificationContent = _resolveComponent("GoogleSpreadSheetNotificationContent")!
  const _component_RoomSettingsAssignFormContent = _resolveComponent("RoomSettingsAssignFormContent")!

  return (_ctx.rcm && _ctx.rcm.room)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.canUseInstantRoom)
            ? (_openBlock(), _createBlock(_component_InstantRoomSettings, { key: 0 }))
            : _createCommentVNode("", true),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _createVNode(_component_CheckboxTag, {
              value: ``,
              name: `expiration_type`,
              checked: _ctx.rcm.room_setting.expiration_type == `permanent`,
              prefix: `expiration_type`,
              onClickCheckbox: _ctx.clickExpirationType,
              style: {"margin-left":"1px","margin-right":"7px"}
            }, null, 8, ["checked", "onClickCheckbox"]),
            _hoisted_9,
            _hoisted_10
          ]),
          (_ctx.showShareTeam)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _createVNode(_component_CheckboxTag, {
                  value: ``,
                  name: `share_type`,
                  checked: _ctx.rcm.room_setting.share_type == `self`,
                  prefix: `share_type`,
                  onClickCheckbox: _ctx.clickShareType,
                  style: {"margin-left":"1px","margin-right":"7px"}
                }, null, 8, ["checked", "onClickCheckbox"]),
                _hoisted_16,
                _hoisted_17
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              (_ctx.rm.didConnectCal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createTextVNode(" 調整相手が確定した際に、 自分と同じ"),
                    (_ctx.rm.did_connect_ms_cal)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Microsoft予定表"))
                      : (_ctx.rm.did_connect_google_cal)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Googleカレンダー"))
                        : _createCommentVNode("", true),
                    _createTextVNode("上のイベントの同席者として書き込まれ、お相手のカレンダー上でもイベントが確認できるようになります。 "),
                    _hoisted_25,
                    _createTextVNode("もしお相手に予定を見られたくない場合は、「オーナーと別イベントとして作成」を選んでください。 ※「オーナーと別イベントとして作成」する場合、お相手がwaaqでカレンダー連携していない場合、自動的にイベントを作成できません ")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_SelectTag, {
                name: "meeting_time",
                id: "select_meeting_time",
                class: "fl fs14 roundForm",
                style: {"min-width":"330px","height":"50px","margin-top":"10px"},
                options: _ctx.CalendarUtil.selectAddEventTypes.map(t => t.name),
                defaultOption: 
                            _ctx.CalendarUtil.selectAddEventTypes.find(
                                t => t.type == (_ctx.rcm.room_setting.add_event_type || `same_event`)
                            ).name
                        ,
                onSelectValue: _ctx.selectAddEventType
              }, null, 8, ["options", "defaultOption", "onSelectValue"]),
              _hoisted_28
            ]),
            _hoisted_29
          ]),
          _hoisted_30,
          (_ctx.rcm.room_setting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _hoisted_32,
                _hoisted_33,
                _hoisted_34,
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", {
                    class: "pointer pad20 rad8 ProviderEventEdit withEditable posRe",
                    style: {"box-shadow":"6px 6px 18px #ddd"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editProviderEvent && _ctx.editProviderEvent(...args)))
                  }, [
                    (_ctx.rcm.room_setting.provider_event_title)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.eventTitle), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createTextVNode(" ●●様（○○株式会社）"),
                          (_ctx.rcm.appeal_content.title)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, "「" + _toDisplayString(_ctx.rcm.appeal_content.title) + "」", 1))
                            : (_ctx.rcm.appo.name)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_40, "「" + _toDisplayString(_ctx.rcm.appo.name) + "」", 1))
                              : _createCommentVNode("", true)
                        ])),
                    _hoisted_41,
                    (_ctx.rcm.room_setting.provider_event_description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _createElementVNode("p", {
                            textContent: _toDisplayString(_ctx.eventDesc)
                          }, null, 8, _hoisted_43)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          (_ctx.rcm.appo.location_name == _ctx.Const.zoomConnectAccount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createTextVNode(" 【Zoom Meeting】"),
                                _hoisted_46,
                                _createTextVNode(" アカウント: waaq@waaq.waaq"),
                                _hoisted_47,
                                _createTextVNode(" ミーティングID: 123456789012"),
                                _hoisted_48,
                                _createTextVNode(" ミーティングパスコード: 123456"),
                                _hoisted_49,
                                _hoisted_50
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" 【waaq Link ページ】"),
                          _hoisted_51,
                          _createTextVNode(" 限定公開ページ: R1234567"),
                          _hoisted_52,
                          _createTextVNode(" 限定公開ページURL: https://waaq.test.jp/schedule?public_id=R1234567 ※ waaq Link ご利用ユーザーのみ有効なリンク"),
                          _hoisted_53,
                          _createTextVNode(" 公開ページURL: https://waaq.test.jp/p/waaq/R1234567"),
                          _hoisted_54,
                          _hoisted_55,
                          _createTextVNode(" 【出席者】"),
                          _hoisted_56,
                          _createTextVNode(" 1"),
                          _hoisted_57
                        ])),
                    _hoisted_58
                  ]),
                  _hoisted_59
                ]),
                _hoisted_60
              ]))
            : _createCommentVNode("", true),
          _hoisted_61,
          _createVNode(_component_OptionalConnectedCalendar),
          _hoisted_62,
          (_ctx.rcm.room_setting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                _hoisted_64,
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createVNode(_component_SelectTag, {
                      name: "cancel_span_names",
                      id: "select_cancel_span_names",
                      class: "fl fs14 roundForm",
                      style: {"min-width":"250px","height":"50px"},
                      options: (_ctx.SelectUtil.additionalMailSubjectTypes || []).map(seldic => seldic.name),
                      defaultOption: 
                                _ctx.SelectUtil.defaultName(
                                    _ctx.SelectUtil.additionalMailSubjectTypes,
                                    _ctx.rcm.room_setting.additional_mail_subject_type_for_owner
                                )
                            ,
                      needUnselect: false,
                      onSelectValue: _ctx.selectAdditionalMailSubjectType
                    }, null, 8, ["options", "defaultOption", "onSelectValue"])
                  ]),
                  (_ctx.rcm.room_setting.additional_mail_subject_type_for_owner != `none`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _createVNode(_component_MdTextfieldTag, {
                            fieldStyle: "min-width:280px;max-width:280px;",
                            style: {"height":"56px","min-width":"280px","max-width":"280px"},
                            class: "fl fs16 mr20",
                            type: `string`,
                            name: `追加する文字を入力`,
                            placeholder: `[管理用]`,
                            value: _ctx.rcm.room_setting.additional_mail_subject_for_owner,
                            onInputValue: _ctx.inputAdditionalMailSubjectForOwner
                          }, null, 8, ["value", "onInputValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_71
                ]),
                _hoisted_72
              ]))
            : _createCommentVNode("", true),
          _hoisted_73,
          _createElementVNode("div", _hoisted_74, [
            _hoisted_75,
            _hoisted_76,
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _hoisted_79,
                _createVNode(_component_SelectTag, {
                  name: "cancel_span_names",
                  id: "select_cancel_span_names",
                  class: "fl fs14 roundForm",
                  style: {"min-width":"250px","height":"50px"},
                  options: (_ctx.SelectUtil.autoShareMyRoomTypes || []).map(seldic => seldic.name),
                  defaultOption: 
                                _ctx.SelectUtil.defaultName(_ctx.SelectUtil.autoShareMyRoomTypes, _ctx.rcm.room_setting.auto_share_my_room_type)
                            ,
                  needUnselect: false,
                  onSelectValue: _ctx.selectAutoShareMyRoomType
                }, null, 8, ["options", "defaultOption", "onSelectValue"])
              ])
            ]),
            _hoisted_80
          ]),
          _hoisted_81,
          (_ctx.rcm.room_setting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                _hoisted_83,
                _hoisted_84,
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _createVNode(_component_SelectTag, {
                      name: "cancel_span_names",
                      id: "select_cancel_span_names",
                      class: "fl fs14 roundForm",
                      style: {"min-width":"250px","height":"50px"},
                      options: (_ctx.SelectUtil.canChangeOrNot || []).map(seldic => seldic.name),
                      defaultOption: _ctx.rcm.room_setting.can_change_appointment_from_other ? `変更可能` : `変更不可`,
                      needUnselect: false,
                      onSelectValue: _ctx.selectCanChangeAppoFromOther
                    }, null, 8, ["options", "defaultOption", "onSelectValue"])
                  ])
                ]),
                _hoisted_88
              ]))
            : _createCommentVNode("", true),
          _hoisted_89,
          (_ctx.from == `public_room`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/logo/google_analytics.png`),
                    width: "26",
                    height: "26",
                    class: "pointer fl mr10",
                    style: {"margin-top":"-4px"}
                  }, null, 8, _hoisted_92),
                  _hoisted_93,
                  _hoisted_94
                ]),
                _hoisted_95,
                _createVNode(_component_MdTextfieldTag, {
                  fieldStyle: "min-width:280px;max-width:280px;",
                  style: {"height":"56px","min-width":"280px","max-width":"280px"},
                  class: "fl fs16 mr20",
                  type: `string`,
                  placeholder: `UA/G/GTM-○○○○○○`,
                  value: _ctx.rcm.room_setting.google_analytics_id,
                  onInputValue: _ctx.inputGAId
                }, null, 8, ["value", "onInputValue"]),
                _hoisted_96,
                _hoisted_97,
                (_ctx.rm.canUseOption(`management_ga_cross_domains`, false))
                  ? (_openBlock(), _createBlock(_component_MdTextfieldTag, {
                      key: 0,
                      name: "",
                      style: {"height":"56px","min-width":"480px","max-width":"280px"},
                      class: "fs16",
                      type: `string`,
                      placeholder: `abc.com,abcde.com`,
                      value: _ctx.rcm.room_setting.ga_cross_domains,
                      onInputValue: _ctx.inputGACrossDomains,
                      onBlur: _ctx.blurGACrossDomains
                    }, null, 8, ["placeholder", "value", "onInputValue", "onBlur"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _hoisted_98,
          (_ctx.from == `public_room`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                _createVNode(_component_HubspotNotificationContent, {
                  noti: _ctx.hubspotDic,
                  scope: `room_setting`,
                  onUpdateNotification: _ctx.updateNotification
                }, null, 8, ["noti", "onUpdateNotification"]),
                _hoisted_100,
                _createVNode(_component_SalesforceNotificationContent, {
                  noti: _ctx.salesforceDic,
                  scope: `room_setting`,
                  onUpdateNotification: _ctx.updateNotification
                }, null, 8, ["noti", "onUpdateNotification"]),
                _hoisted_101,
                _createVNode(_component_GoogleSpreadSheetNotificationContent, {
                  noti: _ctx.googleSpreadSheetDic,
                  scope: `room_setting`,
                  onUpdateNotification: _ctx.updateNotification
                }, null, 8, ["noti", "onUpdateNotification"]),
                _hoisted_102
              ]))
            : _createCommentVNode("", true),
          _hoisted_103,
          _createVNode(_component_RoomSettingsAssignFormContent, { from: `public_room` }),
          (_ctx.from == `public_room`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                _hoisted_105,
                _createVNode(_component_CheckboxTag, {
                  value: ``,
                  name: `mask_members_info`,
                  checked: _ctx.rcm.room_setting.mask_members_info,
                  prefix: `mask_members_info`,
                  onClickCheckbox: _ctx.clickMaskMembersInfo,
                  style: {"margin-left":"1px","margin-right":"7px"}
                }, null, 8, ["checked", "onClickCheckbox"]),
                _hoisted_107,
                _hoisted_108
              ]))
            : _createCommentVNode("", true),
          (_ctx.from == `public_room`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                _hoisted_110,
                _createElementVNode("button", {
                  type: "submit",
                  class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20 padw10 fw600",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createFieldConverter && _ctx.createFieldConverter(...args)))
                }, " 質問コンバーターを作成 "),
                _hoisted_112
              ]))
            : _createCommentVNode("", true),
          _hoisted_113,
          (_ctx.from == `public_room`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                _hoisted_115,
                _hoisted_116,
                _createElementVNode("div", _hoisted_117, [
                  _hoisted_118,
                  _createElementVNode("div", _hoisted_119, [
                    _hoisted_120,
                    _createVNode(_component_MdTextfieldTag, {
                      fieldStyle: "min-width:180px;",
                      style: {"height":"56px","margin-top":"-24px"},
                      class: "fl fs16",
                      type: `ip_addresses_whitelist`,
                      placeholder: `12.12.12.12/24`,
                      value: ((_ctx.rcm.room_setting || {}).ip_addresses_whitelist || []).join(`,`),
                      onInputValue: _ctx.inputIPWhitelist,
                      onClickTextfield: _ctx.clickIPAddresses,
                      maxLength: 10000,
                      min: 3,
                      required: ""
                    }, null, 8, ["placeholder", "value", "onInputValue", "onClickTextfield"])
                  ])
                ]),
                _hoisted_121,
                _createElementVNode("div", _hoisted_122, [
                  _hoisted_123,
                  _createElementVNode("div", _hoisted_124, [
                    _hoisted_125,
                    _createVNode(_component_MdTextfieldTag, {
                      fieldStyle: "min-width:180px;",
                      style: {"height":"56px","margin-top":"-24px"},
                      class: "fl fs16",
                      type: `ip_addresses_whitelist`,
                      placeholder: `12.12.12.12/24`,
                      value: ((_ctx.rcm.room_setting || {}).ip_addresses_blacklist || []).join(`,`),
                      onInputValue: _ctx.inputIPBlacklist,
                      onClickTextfield: _ctx.clickIPAddresses,
                      maxLength: 10000,
                      min: 3,
                      required: ""
                    }, null, 8, ["placeholder", "value", "onInputValue", "onClickTextfield"])
                  ])
                ]),
                _hoisted_126
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_127,
        (_ctx.rcm.room.room_type == `public_room`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
              _hoisted_129,
              _hoisted_130,
              _createElementVNode("div", _hoisted_131, [
                _hoisted_132,
                _createElementVNode("div", _hoisted_133, [
                  _hoisted_134,
                  _createVNode(_component_MdTextfieldTag, {
                    fieldStyle: "min-width:180px;",
                    style: {"height":"56px","margin-top":"-24px"},
                    class: "fl fs16",
                    type: `ip_addresses_whitelist`,
                    placeholder: ``,
                    value: ((_ctx.rcm.room_setting || {}).email_domains_whitelist || []).join(`,`),
                    onInputValue: _ctx.inputEmailDomainsWhitelist,
                    onClickTextfield: _ctx.clickEmailDomains,
                    maxLength: 10000,
                    min: 3,
                    required: ""
                  }, null, 8, ["value", "onInputValue", "onClickTextfield"])
                ]),
                _hoisted_135
              ]),
              _hoisted_136,
              _createElementVNode("div", _hoisted_137, [
                _hoisted_138,
                _createElementVNode("div", _hoisted_139, [
                  _hoisted_140,
                  _createVNode(_component_MdTextfieldTag, {
                    fieldStyle: "min-width:180px;",
                    style: {"height":"56px","margin-top":"-24px"},
                    class: "fl fs16",
                    type: `ip_addresses_whitelist`,
                    placeholder: ``,
                    value: ((_ctx.rcm.room_setting || {}).email_domains_blacklist || []).join(`,`),
                    onInputValue: _ctx.inputEmailDomainsBlacklist,
                    onClickTextfield: _ctx.clickEmailDomains,
                    maxLength: 10000,
                    min: 3,
                    required: ""
                  }, null, 8, ["value", "onInputValue", "onClickTextfield"])
                ])
              ]),
              _hoisted_141
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}